export interface UiToastOptions {
  title: string;
  description?: string;
  severity?: "success" | "danger" | "warning" | "info" | "default" | "primary";
}

let toastImpl: (options: UiToastOptions) => void = () => {};

// the design system surfaces validation errors through the consuming app's
// toast system. call this once at the app entrypoint to wire it up.
export function initUiToast(toast: (options: UiToastOptions) => void): void {
  toastImpl = toast;
}

export function uiToast(options: UiToastOptions): void {
  toastImpl(options);
}
